<template>
  <div>
    <a-modal id='handitem_foot' v-model="visible" width='40rem' on-ok="handleOk1" @cancel="handleCancel(0)"
      :footer="null"
      :keyboard='false' :maskClosable='false' :dialog-style="{ top: '26%',maxWidth: '95vw' }">
      <div class='mark-file'>
        <div style="width: 38rem;font-size: 18px;color: #0C8B97;">

        </div>
      </div>
      <div solt='title' style="position: relative;">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div style="height: 21rem;
    margin-top: 1rem;">
        <video controls="" autoplay="" name="media" width="100%" height="100%" style="background:#000"  muted='true'>
          <source :src="video_url" type="video/mp4">
        </video>
        <!-- <iframe :src="video_url" width="100%" height="100%"></iframe> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
  export default {
    props:['items'],
    data() {
      return {
        visible: true,
        video_url:
        'https://hk.iqmis.com/videos/accountapp/account-eng-mobileapp-test2.mp4',
        params:{}
      }
    },
    mounted() {
      var lang = window.localStorage.guanwanglang
      // this.getdate()
      this.video_url = lang == "eng"?'https://www.qmisgroup.com/videos/accountapp/account-eng-mobileapp-test2.mp4':'https://www.qmisgroup.com/videos/accountapp/account-chi-mobileapp-test.mp4';
    },
    methods: {
      getdate() {
        this.$ajax({
          method: 'post',
          url: this.$api.getNoticeWithid,
          data:{
           "lan": window.localStorage.guanwanglang,
           "noticeid":this.items.noticeid
          }
        }).then(res => {
          if(res.data.qmiscode ===1000){
            this.params = res.data
          }
        })
      },
      handleCancel() {
        this.$emit('child')
      },
      handleOk() {},
      handleClick(event) {
        // If you don't want click extra trigger collapse, you can prevent this:
        event.stopPropagation();
      },
    }
  }
</script>

<style>
  #handitem_foot .ant-modal-close-x {
    /* width: 1rem; */
    /* height: 1rem; */
    position: relative;
        top: -0.4rem;
        left: 0.4rem;
    font-size: 18px  }

  #handitem_foot .ant-modal-content {
    border-radius: 0 !important;
  }
  @media screen and (min-width:2200px){
     .ant-modal-close-x {
      top: 0 !important;
      left: 0 !important;
    }
  }

  /* #handitem_foot .ant-modal-body {
    border: 10px solid #0097a8;
    border-left: 0;
    border-right: 0;
  } */

</style>



// WEBPACK FOOTER //
// src/components/foot/handitemS.vue